export default "__VITE_ASSET__SEVk8Or2__"